<template>
  <div :class="iconClasses">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z"
        fill="currentColor"
      />
    </svg>
  </div>
</template>

<script>
  export default {
    name: 'icon-caret',
    props: {
      extraClasses: {
        type: Array,
        default: function () {
          return []
        },
      },
      direction: {
        type: String,
        default: 'right',
      },
    },
    computed: {
      iconClasses: function () {
        return ['icon', 'icon--caret', 'icon--caret-' + this.direction]
          .concat(this.extraClasses)
          .join(' ')
      },
    },
  }
</script>

<style lang="scss">
  .icon--caret {
    &-up {
      transform: translateY(-0.1em) rotate(-90deg);
    }

    &-down {
      transform: translateY(0.05em) rotate(90deg);
    }

    &-left {
      transform: rotate(180deg);
    }

    &-right {
      transform: translateY(0.05em) rotate(0deg);
    }
  }
</style>
